import { graphql } from '../../gql'

export const LogMeInMutation = graphql(`
  mutation LogMeIn($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
      user {
        id
        fullName
        username
      }
    }
  }
`)
